<template>
  <button
    class="flex justify-between text-left items-center w-full rounded-lg bg-primary-50 dark:bg-primary-950 py-3 px-5 group transition-transform"
  >
    <span class="text-base flex flex-col gap-1">
      <span
        :class="titleClasses"
        class="font-bold leading-5 mb-1"
        v-text="title"
      />
      <span
        v-if="caption"
        class="text-black-600 dark:text-black-300 leading-5 text-sm"
        v-html="caption"
      />
    </span>
    <span class="flex">
      <IconChevronRight
        class="w-6 h-6 ml-auto text-primary transition-transform group-hover:-translate-x-1"
      />
    </span>
  </button>
</template>

<script setup>
import { IconChevronRight } from '@tabler/icons-vue'

defineProps({
  title: {
    type: String,
    default: '',
  },
  caption: {
    type: String,
    default: '',
  },
  titleClasses: {
    type: String,
    default: '',
  },
})
</script>
